import React from 'react';
import mainImg from '../assets/main.jpg';

const CraftSection = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="split">
          <div className="split-img" style={{backgroundImage: `url(${mainImg})`}}></div>
          <div className="split-content">
            <span className="tagline">Le Savoir-Faire</span>
            <h2>Le Plaisir de Créer</h2>
            <p className="description">
              Chaque produit est pensé avec soin pour allier esthétique, originalité et utilité au quotidien. 
              Une marque de créations artisanales pensée pour vous.
            </p>
            <a href="https://www.instagram.com/fabria.store/" target="_blank" rel="noopener noreferrer" className="btn">
              L'Atelier
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CraftSection;
